import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { STATIC_FILE_URL } from '../../../constants';
import ThemeToggleSwitch from '../../ThemeToggleSwitch';

interface MobileHeaderProps {
  onCartClick?: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onCartClick }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: (theme) => theme.palette.background.default,
        boxShadow: 'none',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: '56px !important' }}>
        <IconButton
          edge="start"
          color="inherit"
          onClick={handleBackClick}
          sx={{ p: 1 }}
        >
          <ArrowBack />
        </IconButton>
        
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 600,
              letterSpacing: 0.3,
              cursor: 'pointer',
            }}
            onClick={handleBackClick}
          >
            Mappin
            <img 
              src={`${STATIC_FILE_URL}/pin-icon.png`} 
              width="16px" 
              style={{ marginLeft: '4px' }}
              alt="pin"
            />
          </Typography>
        </Box>
        <Box>
          <ThemeToggleSwitch compact iconOnly />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MobileHeader;
